export class Polyfills {

	public static closestPolyfill() {

		let elementPrototype: any = Element.prototype;

		if (!Element.prototype.matches) {
			Element.prototype.matches = elementPrototype.msMatchesSelector || elementPrototype.webkitMatchesSelector;
		}

		if (!Element.prototype.closest) {
			Element.prototype.closest = function(s) {
				var el = this;

				do {
					if (el.matches(s)) return el;
					el = el.parentElement || el.parentNode;
				} while (el !== null && el.nodeType === 1);
				return null;
			};
		}
	}

	public static run() {
		Polyfills.closestPolyfill();
	}
}